import { FormControl, FormLabel, TextField, Typography } from "@mui/material";

export const TextInput = (props) => {
  const { description = "", label = "", ...restProps } = props;

  return (
    <FormControl>
      {label ? <FormLabel>{label}</FormLabel> : null}

      <TextField {...restProps} />
      {description ? (
        <Typography variant="small" style={{ fontSize: "12px" }}>
          {description}
        </Typography>
      ) : null}
    </FormControl>
  );
};

export default TextInput;
